import { Inject, Injectable } from '@angular/core';
import { ApiCommonService } from 'cbc-shared-lib';
import { Observable, throwError } from 'rxjs';
import { catchError, map, timeout } from 'rxjs/operators';
import { Sgke385aRequest, Sgke385aResponse, Sgke385aService } from 'sg-api';
import { FeaturesLibConfig } from '../../../../../config/features-lib-config';
import { FEATURES_LIB_CONFIG } from '../../../../../config/features-lib-config.token';

@Injectable({
  providedIn: 'root'
})
export class UsedSgke385aService {

  /**
   * コンストラクタ
   * @param {Sgke385aService} service
   * @param {ApiCommonService} apiCommonService
   * @param {FeaturesLibConfig} featuresLibConfig
   * @memberof UsedSgke385aService
   */
  constructor(
    public service: Sgke385aService,
    public apiCommonService: ApiCommonService,
    @Inject(FEATURES_LIB_CONFIG) private featuresLibConfig: FeaturesLibConfig) { }

  /**
   * SGKE385A_サービサー委託対象再委託登録API呼出し
   * @param {Sgke385aRequest} request 
   * @returns {*}  {Observable<Sgke385aResponse>}
   * @memberof UsedSgke385aService
   */
  public doSgke385a(request: Sgke385aRequest): Observable<Sgke385aResponse> {

    return this.service.sgke385aPost(this.apiCommonService.setRequestCommon(<any>request), 'response')
      .pipe(
        map(
          response => {
            // エラーが設定されていないかチェックし、エラーの場合catchError()に処理が移る
            this.apiCommonService.checkError(response);
            return response.body;
          }),

        timeout(Number(this.featuresLibConfig.httpTimeout)),
        catchError((err) => {
          this.apiCommonService.dispErrorMessage(err, 'bill', 'SGKE385A');
          return throwError(err.message);
        })
      );
  }

}
